import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { bsc, bscTestnet, baseSepolia, sepolia } from 'wagmi/chains';

export const config = getDefaultConfig({
  appName: 'ZKPool',
  projectId: '9b592784e625dd3889781ba6a2acc866',
  chains: [bsc, bscTestnet, baseSepolia, sepolia],
  // Disable Wagmi/RainbowKit server-side rendering so WalletConnect
  // libraries (which expect browser globals like indexedDB) only run in the browser.
  ssr: false,
});
